export enum IndividualSavingsQueryKeys {
  GET_INDIVIDUAL_VAULT_SAVINGS_STATS = "get-individual-vault-savings-stats",
  GET_INDIVIDUAL_VAULT_SAVINGS = "get-individual-vault-savings",
  GET_INDIVIDUAL_VAULT_SAVINGS_DETAILS = "get-individual-vault-savings-details",
  GET_INDIVIDUAL_VAULT_SAVINGS_TRANSACTIONS = "get-individual-vault-savings-transactions",
  GET_INDIVIDUAL_VAULT_SAVINGS_TRANSACTIONS_STATS = "get-individual-vault-savings-transactions-stats",
  GET_INDIVIDUAL_SAVINGS_COUNT = "get-individual-savings-count",
}
